
import Vue from 'vue';
import WaitListQueueIndex from '../components/wait_list_queue/WaitListQueueIndex.vue';
Vue.component('wait-list-queue-index', WaitListQueueIndex);

export default Vue.extend({
  components: { WaitListQueueIndex },
});
